import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const DetailsLink = styled(Link)`
  text-decoration: none;
  color: ${(p) => p.theme.palette.primary[500]};
  font-size: ${(p) => p.theme.typography.caption};
`;
